<template>
	<div class="home">
		<div class="banner_box" v-if="banner.length > 0 && banner[0].type == 1">
			<el-carousel
				height="calc(var(--proportion) * 640px)"
				ref="cardShow"
				arrow="never"
				@change="changeFun"
			>
				<el-carousel-item v-for="(item, index) in banner" :key="index">
					<img
						style="width: 100%; height: 100%; object-fit: cover; cursor: pointer"
						:src="item.image"
						alt=""
						@click="onBindToUrl(item.url)"
					/>
				</el-carousel-item>
			</el-carousel>

			<!-- <div class="arrow_box">
        <div class="left">
          <img
            class="animate__animated animate__rubberBand"
            @click="arrowClick('left')"
            src="../image/zjt1.png"
            alt=""
          />
        </div>
        <div class="mid">
          <span style="font-size: 38px; color: #e60000">{{
            carouselIndex
          }}</span
          >/{{ banner.length }}
        </div>
        <div class="right">
          <img @click="arrowClick('right')" src="../image/yjt1.png" alt="" />
        </div>
      </div> -->
		</div>
		<div class="banner_box video" v-if="banner.length > 0 && banner[0].type == 2">
			<video
				:src="banner[0].image"
				class="banner_box-video"
				autoplay
				loop
				muted
				@click="onBindToUrl(banner[0].url)"
			></video>
		</div>
		<!--  -->
		<div class="serve_box">
			<div style="top: 0px; left: 0" class="serve_box-bj center">
				<img src="../image/index/qiu1.png" alt="" />
			</div>
			<div class="dividing-line serive"></div>
			<div class="title" v-if="photo.title">
				<!--未解决 报红来源，好像是因为页面渲染太快了，数据还没有渲染上去，导致报错 ！！参考资料https://blog.csdn.net/m0_67393413/article/details/123398477?spm=1001.2101.3001.6650.1&utm_medium=distribute.pc_relevant.none-task-blog-2%7Edefault%7ECTRLIST%7Edefault-1-123398477-blog-123795122.pc_relevant_downloadblacklistv1&depth_1-utm_source=distribute.pc_relevant.none-task-blog-2%7Edefault%7ECTRLIST%7Edefault-1-123398477-blog-123795122.pc_relevant_downloadblacklistv1&utm_relevant_index=2-->
				<div class="top headline">{{ photo.title.name }}</div>
				<div class="bottom small_caption">{{ photo.title.vice_name }}</div>
			</div>
			<div class="card_box">
				<div
					v-for="(item, index) in photo.photo"
					:key="index"
					class="card wow animate__animated animate__fadeInUp"
					@mouseenter="show_card(index)"
					@mouseleave="hidden_card"
					@click="toPagesUrl(index)"
				>
					<div></div>
					<img :src="item.image" alt="" />
					<div class="nr">
						<div class="top">
							<!-- <div class="big_title">{{ serviceName[index].name }}</div>
              <div class="little_title">{{ serviceName[index].english }}</div> -->
						</div>
						<div v-show="index != card_index" class="bottom animate__animated animate__fadeInUp">
							<div class="top"></div>
							<div class="bottom">{{ item.title }}</div>
						</div>

						<div v-show="index == card_index" class="bottom animate__animated animate__pulse">
							<div class="top1 animate__animated animate__fadeInUp">
								{{ item.title }}
							</div>
							<div class="bottom1 hover-a">
								查看详情
								<img src="../image/jiantou1.png" alt="" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--  -->

		<!-- 智能场景体验 -->
		<div class="serve_box" style="margin-bottom: -25px">
			<div class="dividing-line serive"></div>
			<div class="title">
				<div class="top headline">智能场景体验</div>
				<div class="bottom small_caption"> 随心享光，营造全场景智慧照明新感受 </div>
				<div style="top: -35px" class="serve_box-bj">
					<img style="width: 100%" src="../image/index/qiu2.png" alt="" />
				</div>
			</div>

			<div class="video_box wow animate__animated animate__fadeInUp">
				<!-- 体验场景大图 -->
				<div>
					<!-- v-if="swiperIndex == index" -->
					<div
						class="video-image-box"
						v-if="false"
						v-for="(item, index) in sceneDataList"
						:key="index"
					>
						<!-- {{ item.children[Number(activeSceneChild)]["is_scene"]
            }}{{ activeSceneChild }} -->
						<img
							v-if="item.children[Number(activeSceneChild)].is_scene == 1"
							:src="item.children[Number(activeSceneChild)]['url']"
							class="video-image-box-img"
							alt=""
						/>
						<video
							autoplay
							loop
							class="video-image-box-img"
							v-else
							:src="item.children[Number(activeSceneChild)]['url']"
							alt=""
						></video>
					</div>

					<!-- 体验场景大图 Swiper -->
					<div
						class="scene_swiper_box at-container"
						v-for="(items, indexs) in sceneDataList"
						:key="indexs"
					>
						<swiper
							class="at-item swiper-no-swiping"
							v-show="indexs == swiperIndex"
							:options="sceneSwiperOption"
							ref="sceneSwiper"
						>
							<!-- v-for="(item, index) in sceneDataList[swiperIndex].children" -->
							<swiper-slide
								class="scene_swiper"
								v-for="(item, index) in items.children"
								:key="index"
							>
								<img
									v-if="item.is_scene == 1"
									:src="item['url']"
									class="scene_video-image-box-img"
									alt=""
								/>
								<video
									autoplay
									loop
									class="scene_video-image-box-img"
									v-else
									:src="item['url']"
									alt=""
								></video>
							</swiper-slide>
						</swiper>
					</div>
					<div class="poprop-bottom-black"></div>
				</div>
				<div class="video_box_nav">
					<div class="box_nav_left">
						<!-- 导航轮播图 -->
						<div class="swiper_box">
							<!-- Swiper -->
							<swiper :options="swiperOption" ref="mySwiper">
								<swiper-slide
									class="swiper_item"
									v-for="(item, index) in sceneDataList"
									:key="index"
									:class="[swiperIndex == index ? 'video_active_item' : '']"
								>
									<div
										class="swiper-title"
										:class="{ active: swiperIndex == index }"
										@click="xuanze(item, index)"
									>
										{{ item.name }}
									</div>
									<img
										:class="['video_swper_img', 'video_active_img', 'transition_effect']"
										:src="item.image"
									/>
								</swiper-slide>
							</swiper>
						</div>
					</div>

					<!-- 体验场景 模式导航 -->
					<div class="box_nav_right">
						<el-tabs v-model="activeSceneChild" @tab-click="xuanze1">
							<el-tab-pane v-for="(key, i) in sceneChild" :key="i">
								<div slot="label">
									{{ key.name }}
								</div>
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>
			</div>
		</div>

		<!-- 智能照明素材 -->
		<div style="overflow: hidden" class="serve_box wow animate__animated animate__fadeInUp">
			<div class="dividing-line" style="margin-top: 60px"></div>
			<div class="title">
				<div class="top headline">{{ material.name }}</div>
				<div class="bottom small_caption mar-bottom">
					{{ material.vice_name }}
				</div>

				<div class="serve_box_button hover-a" @click="dettagliChange">
					查看详情
					<img src="../image/jiantou1.png" alt="" />
				</div>
			</div>
			<!-- :controls="!bottomVideoPlayShow" -->
			<div
				class="video_box bottom"
				style="padding-left: 10%; padding-right: 10%"
				v-if="material.url"
			>
				<!-- controls="true"
          @play="bottomVideoPlayShow = false"
          @pause="bottomVideoPlayShow = true" -->
				<!-- <video
          autoplay
          loop
          muted
          :src="material.url"
          ref="bottomVideo"
        ></video> -->
				<!-- <img
          src="../assets/icon/bf@2x.png"
          v-if="false"
          @click="onBottomVideoPlay"
          class="video-play"
          alt=""
        /> -->
				<div class="video-body">
					<video class="video" autoplay loop muted :src="material.url" ref="bottomVideo"></video>
				</div>
			</div>
			<div style="position: absolute; top: 0; right: 0" class="serve_box-bj">
				<img style="width: 100%" src="../image/index/qiu3.png" alt="" />
			</div>
		</div>
	</div>
</template>

<script>
	import { $getBannerHome, $get_photo, $get_scene, $get_material } from '@/api/index';

	import { swiper, swiperSlide } from 'vue-awesome-swiper';
	import 'swiper/dist/css/swiper.css';
	// @ is an alias to /src
	export default {
		name: 'Home',
		data() {
			return {
				cardBoxTimer: null,
				bannerIndex: 0,
				card_index: -1,
				activeRoomType: 0,
				banner: [],
				photo: {},
				serviceName: [
					{
						name: '智能照明',
						english: 'Lighting design',
						url: '/smart_lighting',
					},
					{
						name: '西顿舍见SMI',
						url: "https://cdn.thethinking.cn/#/pages/login/login",
    					english: "cloudDesign",
					},
					{
						name: '设计下单',
						english: 'Cloud Design',
						url: '/technical_services',
					},
					{
						name: '设计方案',
						english: 'Lighting design',
						url: '/smart_lighting#dasgin_share',
					},
					
					
					// {
					// 	name: '家装案例',
					// 	english: 'Design order',
					// 	// url: "/smart_lighting/#dasgin_share",
					// 	url: 'https://www.kujiale.com/pub/site/design-zone/3D7RG7YHD3UG/designs?kpm=qkWL.8411f11a25ad0e71.1f62acb.1688463005503',
					// },
				],

				// 智能场景数据
				sceneDataList: [], // 数据列表
				sceneChild: [], // 模式   数据
				sceneImg: '', // 大图
				swiperIndex: 0, // 轮播图 导航索引
				activeSceneChild: '0',
				material: {},
				bottomVideoPlayShow: true,

				// 场景swiper
				sceneSwiperOption: {
					initialSlide: 0, // 初始化 索引
				},

				// swiper
				swiperOption: {
					initialSlide: 0, // 初始化 索引
					slidesPerView: 2,
					slideToClickedSlide: true,
					freeMode: true,
					centeredSlides: true,
				},
			};
		},
		computed: {
			swiper() {
				return this.$refs.mySwiper.swiper;
			},
			carouselIndex() {
				if (this.banner.length > 0) {
					return this.bannerIndex + 1 > 10 ? this.bannerIndex + 1 : `0${this.bannerIndex + 1}`;
				} else {
					return 0;
				}
			},
		},
		components: {
			swiper,
			swiperSlide,
		},
		created() {
			// console.log(this.$store.state.userInfo);
		},
		mounted() {
			this.getBanner();
			this.get_photo();
			this.get_scene();
			this.get_material();
			new this.$wow.WOW({
				boxClass: 'wow',
				animateClass: 'animate__animated',
				offset: -20,
				mobile: true,
				live: true,
			}).init();

			// 监听页面滚动事件
			window.addEventListener('scroll', this.scrolling);
			this.$store.commit('setHeadPlaceholder', false);
		},
		methods: {
			scrolling(e) {
				// 页面滚动距顶部距离
				var scrollTop =
					window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				var scroll = scrollTop - this.i;
				this.i = scrollTop;

				this.$store.commit('setHeaderShow', !(scroll < 0));
			},
			onBottomVideoPlay() {
				this.$refs.bottomVideo.play();
			},
			toPagesUrl(index) {
				console.log(index);
				
				const url = this.serviceName[index].url;
				if (url.indexOf('https') !== -1) {
					window.location.href = url;
				} else {
					this.$router.push({
						path: this.serviceName[index].url,
					});
				}
			},

			onBindToUrl(ev) {
				let a = document.createElement('a');
				a.href = ev;
				a.target = '_blank';
				a.click();
			},
			get_material() {
				$get_material()
					.then((response) => {
						this.material = response.data;
					})
					.catch((res) => {
						console.log(res);
					});
			},
			xuanze1(e, index) {
				this.$forceUpdate();

				// 切换 场景模式图
				// console.log(this.$refs.sceneSwiper[this.swiperIndex]);
				// this.$refs.sceneSwiper.swiper.slideTo(this.activeSceneChild, 1000, false);//切换到第一个index，速度为1秒
				this.$refs.sceneSwiper[this.swiperIndex].swiper.slideTo(this.activeSceneChild, 1000, false); //切换到第一个index，速度为1秒
			},

			// 智能场景体验 数据 导航
			xuanze(e, index) {
				// swiper
				this.swiperIndex = index;
				this.sceneChild = e.children;
				this.activeSceneChild = '0';

				// 切换 场景 导航图
				// this.$refs.sceneSwiper.swiper.slideTo(this.activeSceneChild, 1000, false);//切换到第一个index，速度为1秒
				this.$refs.sceneSwiper[this.swiperIndex].swiper.slideTo(this.activeSceneChild, 1000, false); //切换到第一个index，速度为1秒
			},

			handleClickRoomType(e) {
				console.log(e);
			},
			// 获取智能场景体验 数据
			get_scene() {
				$get_scene()
					.then((res) => {
						// console.log('获取智能场景体验', res.data);
						this.sceneDataList = res.data;
						this.sceneChild = res.data[0].children;
						this.sceneImg =
							res.data.length != 0 && res.data[0].children.length != 0
								? res.data[0].children[0].url
								: '';
					})
					.catch((err) => {
						console.log(err);
					});
			},
			get_photo() {
				$get_photo()
					.then((response) => {
						this.photo = response.data;
					})
					.catch((res) => {
						console.log(res);
					});
			},
			// 获取轮播图
			getBanner() {
				$getBannerHome({
					page_tyle: 1,
				})
					.then((response) => {
						this.banner = response.data;
					})
					.catch((res) => {
						console.log(res);
					});
			},
			show_card(e) {
				if (this.cardBoxTimer) {
					clearTimeout(this.cardBoxTimer);
				}
				this.cardBoxTimer = setTimeout(() => {
					this.card_index = e;
				}, 300);
			},
			hidden_card() {
				this.card_index = -1;
			},
			changeFun(e) {
				// console.log(e);
				this.bannerIndex = e;
			},
			arrowClick(val) {
				if (val === 'right') {
					this.$refs.cardShow.next();
				} else {
					this.$refs.cardShow.prev();
				}
			},

			// 智能详情跳转
			dettagliChange() {
				this.$router.push({
					path: '/smart_lighting/#dasgin_title',
				});
			},
		},
		beforeDestroy() {
			this.$store.commit('setHeaderShow', true);
			this.$store.commit('setHeadPlaceholder', true);
			window.removeEventListener('scroll', this.scrolling);
		},
	};
</script>
<style lang="scss" scoped>
	.home {
		position: relative;
		box-sizing: border-box;
		width: 100%;
		min-height: 100vh;
		min-width: 1100px;
	}

	.banner_box.video {
		width: 100%;
		// height: calc(var(--proportion) * 700px);
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.banner_box-video {
		max-width: 100%;
		width: 100%;
		// max-height: 100%;
	}
	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 600px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n + 1) {
		background-color: #d3dce6;
	}
	.banner_box {
		position: relative;
		z-index: 2;
		width: 100%;
		.arrow_box {
			width: 270px;
			height: 72px;
			background: #100f0f;
			position: absolute;
			bottom: 0;
			right: 0;
			z-index: 999;
			display: flex;
			align-items: center;
			justify-content: space-around;
			.left {
				cursor: pointer;
			}
			.mid {
				color: #ffffff;
				line-height: 18px;
				opacity: 0.5;
				font-size: 20px;

				font-weight: bold;
				display: flex;
			}
			.right {
				cursor: pointer;
			}
		}
	}
	//
	.serve_box {
		// padding-top: 30px;
		background-color: #100f0f;
		position: relative;
		.serve_box-bj.center {
			top: 50px !important;
			left: 0px !important;
			z-index: 0;
			width: calc(var(--proportion) * 1680px);
			height: calc(var(--proportion) * 860px);
			img {
				width: 100%;
				height: 100%;
			}
		}
		.serve_box-bj {
			position: absolute;
			overflow: hidden;
		}
		.title {
			position: relative;
			z-index: 2;
			text-align: center;
			// padding-top: 32px;
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			.top {
				font-size: 48px;
				letter-spacing: 2px;
				width: 100%;
				color: #ffffff;
				z-index: 999;
				line-height: 1;
				opacity: 0.85;
				margin-bottom: 24px;
			}
			.bottom {
				width: 100%;
				font-size: 28px;
				letter-spacing: 2px;
				font-weight: 500;
				z-index: 999;
				color: #ffffff;
				line-height: 28px;
				opacity: 0.5;
			}

			.serve_box_button {
				cursor: pointer;
				width: 155px;
				height: 48px;
				margin-bottom: 64px;
				line-height: 48px;
				text-align: center;
				border: 1px solid #ffffff;
				opacity: 0.85;
				font-size: 14px;

				font-weight: 400;
				color: #ffffff;
				z-index: 999;
				// margin-top: 15px;

				// &:hover {
				//   background: #e60000;
				//   border: 0px solid #ffffff !important;
				// }
			}
		}
		.video_box.bottom {
			position: relative;
			width: 100%;
			// height: calc(var(--proportion) * 940px);
			display: flex;
			justify-content: center;
			align-items: center;
			video {
				// pointer-events: none;
				max-width: 100%;
				// max-height: 100%;
				width: 100%;
				/* height: 100%; */
			}
		}
		.video_box {
			width: 100%;
			// cursor: pointer;
			// margin-top: 62px;
			// padding:0 10% 85px;
			padding-bottom: 85px;
			// display: flex;
			// justify-content: space-between;
			position: relative;
			z-index: 2;
			.video-image-box {
				height: calc(var(--proportion) * 790px);
				width: 100%;
				z-index: 1;
				.video-image-box-img {
					width: 100%;
					height: 100%;
				}
			}
			.scene_swiper {
				height: calc(var(--proportion) * 790px);
				width: 100% !important;
				z-index: 1;
				.scene_video-image-box-img {
					width: 100%;
					height: 100%;
				}
			}
			.video_box_nav {
				left: 50px;
				width: 80%;
				position: absolute;
				display: flex;
				align-items: center;
				bottom: 25px;
				z-index: 999;
				.box_nav_left {
					// width: 500px;
					// overflow: scroll;
					display: flex;
					padding-bottom: 10px;
					box-sizing: border-box;
					.swiper_box {
						position: relative;
						width: 600px;
						height: 145px;
						margin-right: 32px;
						cursor: pointer;
						.swiper_item:hover {
							img {
								transform: scale(1.2);
								transition: all 0.5s;
							}
							.swiper-title {
								opacity: 0.8;
							}
						}
						.swiper_item {
							position: relative;
							width: 300px;
							height: 100%;
							margin-right: 24px;
							background: #100f0f;
							overflow: hidden;

							.swiper-title.active {
								opacity: 0.8;
							}
							.swiper-title {
								position: absolute;
								top: 0px;
								left: 0px;
								color: #fff;
								font-size: 20px;

								font-weight: bold;
								z-index: 2;
								width: 100%;
								height: 100%;
								display: flex;
								justify-content: center;
								align-items: center;
								opacity: 0.5;
							}
						}
						.video_swper_img {
							width: 100%;
							height: 100%;
							opacity: 0.65;
						}
						.video_active_item {
							overflow: hidden;
							border: 4px solid #e60000;
							box-sizing: border-box;
							.video_active_img {
								opacity: 1;
								transform: scale(1.2);
								box-sizing: border-box;
							}
						}
						// .swiper-button-prev{
						//   top: 50%;
						//   left: -3px;
						//   background-size: 14px 20px;
						//   transform: translateY(-50%);
						//   opacity: 0.5;
						// }
						// .swiper-button-next {
						//   top: 50%;
						//   right: -3px;
						//   background-size: 14px 20px;
						//   transform: translateY(-50%);
						//   opacity: 0.5;
						// }
					}

					/* 定义滚动条样式 */
					&::-webkit-scrollbar {
						/*滚动条整体样式*/
						width: 0px;
						/*高宽分别对应横竖滚动条的尺寸*/
						height: 5px;
					}

					/*定义滚动条轨道 内阴影+圆角*/
					&::-webkit-scrollbar-track {
						box-shadow: inset 0 0 0px rgba(180, 180, 180, 0.5);
						border-radius: 10px;
						background-color: rgb(17, 17, 17);
					}
					/*定义滑块 内阴影+圆角*/
					&::-webkit-scrollbar-thumb {
						border-radius: 10px;
						box-shadow: inset 0 0 0px rgba(180, 180, 180, 0.5);
						background-color: rgb(78, 74, 74);
					}
				}
				.box_nav_right {
					margin-left: calc(var(--proportion) * 200px);
					margin-bottom: 20px;
					font-size: 24px;
					font-family: Alibaba PuHuiTi 2;
					font-weight: normal;
					color: #ffffff;
					// opacity: 0.85;
					display: flex;
					flex: 1;
					justify-content: space-between;
					::v-deep .el-tabs__nav-wrap::after {
						background-color: transparent !important;
					}

					::v-deep {
						// 标签页box
						.el-tabs__nav {
							margin-top: -3px;
						}
						// 标签页
						.el-tabs__item {
							position: relative;
							z-index: 4;
							padding: 0 calc(var(--proportion) * 40px);
							font-size: 0.73rem;
							font-family: Alibaba PuHuiTi 2;
							font-weight: normal;
							color: rgba(255, 255, 255, 0.85) !important;
							margin-bottom: 32px;
							margin-top: -3px;
						}
						// 底边
						.el-tabs__active-bar {
							bottom: 4px;
							height: 4px;
							background: #e60000;
							top: 30px;
						}
					}
				}
			}
			.video-body {
				position: relative;
				width: 100%;
				padding-bottom: 56.5%;
				.video {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
				}
			}
		}

		.card_box {
			// margin-top: 64px;
			// padding-bottom: 162px;
			display: flex;
			justify-content: space-between;
			width: 95%;
			margin-left: 2.5%;
			position: relative;
			z-index: 9;
			.card {
				cursor: pointer;
				width: calc(var(--proportion) * 435px);
				height: calc(var(--proportion) * 620px);
				position: relative;
				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
				.nr {
					overflow: hidden;
					padding: 35px;
					width: 100%;
					height: 100%;
					position: absolute;
					top: 0;
					display: flex;
					flex-wrap: wrap;
					align-content: space-between;
					transition: background-color 1s linear, color 1s linear;
					-webkit-transition: background-color 1s linear, color 1s linear;
					-moz-transition: background-color 1s linear, color 1s linear;
					-o-transition: background-color 1s linear, color 1s linear;
					background-color: rgba(0, 0, 0, 0.3);
					&:hover {
						background-color: rgba(0, 0, 0, 0);
						color: blue;
					}
					.top {
						width: 100%;
						.big_title {
							margin-bottom: 23px;
							font-size: 1.5rem;

							font-weight: bold;
							color: #ffffff;
							line-height: 1.56rem;
							opacity: 0.85;
						}
						.little_title {
							font-size: 16px;

							font-weight: 400;
							color: #ffffff;
							line-height: 28px;
							opacity: 0.7;
						}
					}
					.bottom {
						.top {
							width: 18px;
							height: 4px;
							background: #ffffff;
						}
						.bottom {
							margin-top: 30px;
							font-size: 18px;

							font-weight: 400;
							color: #ffffff;
							// line-height: 30px;
							opacity: 0.7;
						}

						.top1 {
							font-size: 24px;

							font-weight: 500;
							color: #ffffff;
							// line-height: 40px;
							opacity: 0.85;
						}
						.bottom1 {
							cursor: pointer;
							width: 124px;
							height: 48px;
							font-size: 14px;

							font-weight: 400;
							color: #ffffff;
							border: 1px solid #fff;
							line-height: 28px;
							margin-top: 32px;
							transition: background-color 0.1s linear, color 1s linear;
							-webkit-transition: background-color 1s linear, color 1s linear;
							-moz-transition: background-color 1s linear, color 1s linear;
							-o-transition: background-color 1s linear, color 1s linear;
							display: flex;
							align-items: center;
							justify-content: center;
							img {
								width: 12px;
								height: 12px;
								margin-left: 5px;
							}

							&:hover {
								background-color: rgb(112, 24, 24);
							}
						}
					}
				}
			}
		}
	}

	// 轮播图导航
	::v-deep {
		.swiper-container {
			// width: 100%;
			height: 100% !important;
		}
		.swiper-slide,
		.swiper-slide-active {
			width: 262px !important;
		}
		.swiper {
			--swiper-navigation-color: #cccccc25; /* 单独设置按钮颜色 */
			--swiper-navigation-size: 16px; /* 设置按钮大小 */
		}
	}

	.video-play:active {
		opacity: 0.8 !important;
	}
	.video-play:hover {
		opacity: 1;
	}
	.video-play {
		position: absolute;
		// top: 50%;
		// transform: translate(-50%, -50%);
		left: 50%;
		width: 80px;
		height: 80px;
		opacity: 0.9;
	}
	.dividing-line.serive {
		margin-top: 90px;
	}

	// 横杆
	.dividing-line {
		display: none;
		position: relative;
		z-index: 4;
		margin: 0px auto;
		width: 40px;
		height: 2px;
		background: #e60000;
	}
	.poprop-bottom-black {
		position: absolute;
		bottom: 85px;
		left: 0px;
		width: 100%;
		height: 100px;
		background-image: linear-gradient(180deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
	}

	.hover-a:hover {
		opacity: 1 !important;
	}

	// 轮播图指示器
	::v-deep {
		.el-carousel__button {
			width: calc(var(--proportion) * 40px);
			height: calc(var(--proportion) * 4px);
		}
		.is-active {
			.el-carousel__button {
				background: #e60000 !important;
			}
		}
	}

	.scene_swiper_box {
		background-color: #000;
	}

	// 过渡
	.at-container {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}
	.at-item {
		width: 100%;
		height: 100%;
		background-color: transparent;
		animation-name: fade-in-top;
		animation-duration: 1s;
		animation-timing-function: ease;
		animation-delay: 0s;
		animation-iteration-count: 1;
		animation-direction: normal;
		animation-fill-mode: none;
		/* shorthand 
  animation: fade-in-top 1s ease 0s 1 normal none;
  */
	}
	@keyframes fade-in-top {
		0% {
			transform: translateY(-50px);
			opacity: 0.4;
		}
		100% {
			transform: translateY(0);
			opacity: 1;
		}
	}

	// 视频高度
	.serve_box .video_box.bottom video {
		height: calc(var(--proportion) * 865px);
	}

	// 大字标题
	.headline {
		padding-top: calc(var(--proportion) * 148px);
		margin-bottom: calc(var(--proportion) * 48px) !important;
		// font-size: calc(var(--proportion) * 52px) !important;
		font-size: 28px !important;
		font-weight: 600;
		letter-spacing: 4px !important;
	}
	// 小字副标题
	.small_caption {
		opacity: 0.7 !important;
		margin-bottom: calc(var(--proportion) * 92px) !important;
		font-weight: 'PingFang SC', Helvetica, 'Microsoft YaHei';
		// font-size: calc(var(--proportion) * 16px) !important;
		font-size: 15px !important;
		font-weight: 100 !important;
		line-height: 1 !important;
	}

	.mar-bottom {
		margin-bottom: calc(var(--proportion) * 48px) !important;
	}
</style>
